import { render } from "./DefaultPageIcon.vue?vue&type=template&id=24279182"
import script from "./DefaultPageIcon.vue?vue&type=script&lang=js"
export * from "./DefaultPageIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__